
import { Directive, HostListener, ElementRef,Input,Output, EventEmitter } from '@angular/core';

@Directive({
    selector: '[onlyAlphabetsWithSpacesAllowed]'
})
export class OnlyAlphabetsWithSpacesAllowedDirective {
    onlyNumber: boolean = false;

    regexStr = '^(?!\s*$).+';
    constructor(private el: ElementRef) {
    }

    @HostListener('keypress', ['$event']) onKeyPress(event) {
        return new RegExp(this.regexStr).test(event.key);
    }

    @HostListener('paste', ['$event']) blockPaste(event: KeyboardEvent) {
        this.validateFields(event);
    }

    validateFields(event) {
        setTimeout(() => {
            if (!new RegExp(this.regexStr).test(this.el.nativeElement.value)) {
                this.onlyNumber = true
                this.el.nativeElement.value = null;
                event.preventDefault();
            }
        }, 100)
    }


}
